import DOMPurify from 'dompurify';
import { marked, Tokens } from 'marked';

export class MarkdownToHtmlConverter {
  public static async markdownToHtml(markdownString?: string): Promise<string | undefined> {
    if (!markdownString) {
      return undefined;
    }
    const renderer = new marked.Renderer();

    renderer.link = ({ href, title, text }: Tokens.Link): string =>
      `<a target="_blank" href="${href}" title="${title ?? text ?? ''}">${text}</a>`;

    return DOMPurify.sanitize(await marked(markdownString, { renderer }), { ADD_ATTR: ['target'] });
  }
}
